module.exports = "/images/btn_close_on.png?5e22ce0ecf484c75c85f43adce8e6109";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/image/icon/btn_close_on.png
// module id = Zi8q
// module chunks = 2 3 4 5 6